import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none"><path d="M.855.855l8.29 8.29M.855 9.145l8.29-8.29" stroke="currentcolor" stroke-linecap="square"/></svg>`;

export { symbol as default };
